import LocalImages from "assets/images/local-images";
import { FC } from "react";

import FlipDocumentAnimationRoot from "./styles/FlipDocumentAnimationRoot.styled";
import Content, { ContentNS } from "content/content";

// TODO Alex return mrz side configuration
const FlipDocumentAnimation: FC = () => {
  const textUI = (s: string) => Content.shared.t(s, { ns: ContentNS.ui });
  return (
    <FlipDocumentAnimationRoot>
      <div className="flip">
        <div className="front">
          <img
            src={LocalImages.shared.images.icons.scannerOverlayDocFrontNoMrz}
            alt={textUI("scanner-overlay.flip-icon-alt")}
          />
        </div>
        <div className="back">
          <img
            src={LocalImages.shared.images.icons.scannerOverlayDocBackMrz}
            alt={textUI("scanner-overlay.flip-icon-alt")}
          />
        </div>
      </div>
    </FlipDocumentAnimationRoot>
  );
};

export default FlipDocumentAnimation;
